import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
const DropdownButton = () => {
  const [option1, setOption1] = useState<any>(null);

  const cities = [
    { name: "AA114137", code: "37" },
    { name: "AA114136", code: "36" },
    { name: "AA114135", code: "35" },
    { name: "AA114134", code: "34" },
    { name: "AA114133", code: "33" },
  ];

  const onCityChange = (e: { value: any }) => {
    setOption1(e.value);
  };

  return (
    <div className="dropdown-demo">
      <div className="card">
        <Dropdown
          value={option1}
          options={cities}
          onChange={onCityChange}
          optionLabel="name"
          placeholder="AA114138"
        />
      </div>
    </div>
  );
};

export default DropdownButton;
